import { inject, observer } from "mobx-react";
import * as React from "react";
import * as DocumentReader from "../DocumentReader";
import { Toolbar } from "../General/Toolbar";
import { TypeAheadSearchInput } from "../General/TypeAheadSearchInput";
import * as Shared from "../Shared";
import { DocumentSearchStore } from "../Stores/DocumentSearchStore";

interface IAdditionalFilterValuesSelection {
	store?: DocumentSearchStore;
}

@inject('store')
@observer
export class AdditionalFilterValuesSelection extends React.Component<IAdditionalFilterValuesSelection, {}> {

	handleSearchTermChangeFromTypeAhead = (searchTerm: string) => {
		this.props.store.additionalFilterValuesWizardState.searchTerm = searchTerm;
		clearTimeout(this.props.store.additionalFilterValuesWizardState.searchTimeoutHandle);
		this.props.store.additionalFilterValuesWizardState.searchTimeoutHandle = setTimeout(() => this.props.store.additionalFilterValuesWizardState.loadAdditionalFilterValues(), 300);
	}

	render() {
		return <div className="wizardbox-content">
			<Toolbar>
				<TypeAheadSearchInput showSuggestionList={false} searchTermChangeCallback={this.handleSearchTermChangeFromTypeAhead} />
			</Toolbar>
			<div className="wizardbox-module">
				<div className="list-simple">
					<AdditionalFilterValues />
				</div>
			</div>
		</div>;
	}
}

@inject('store')
@observer
class AdditionalFilterValues extends React.Component<IAdditionalFilterValuesSelection, {}>{

	store: DocumentSearchStore;

	componentWillMount() {
		this.store = this.props.store;
	}

	componentDidMount() {
		this.store.additionalFilterValuesWizardState.resetWizardBox();
		this.store.additionalFilterValuesWizardState.loadAdditionalFilterValues();
	}

	handleClickItem = (filterValue: DocumentReader.SearchFilterValue) => {

		if (this.store.additionalFilterValuesWizardState.currentFilterToAddFilterValues.filterMode == Shared.FilterMode.Single) {
			this.store.resetFilterValuesOfTypeSingle(filterValue, this.store.additionalFilterValuesWizardState.additionalFilterValues);
			this.store.additionalFilterValuesWizardState.selectedAdditionalFilterValues.clear();
		}
		filterValue.isSelected = !filterValue.isSelected;
		let alreadSelected = this.store.additionalFilterValuesWizardState.selectedAdditionalFilterValues.find(value => value == filterValue);
		if (!alreadSelected) {
			this.store.additionalFilterValuesWizardState.selectedAdditionalFilterValues.push(filterValue);
		}
	}

	itemClass = (filterValue: DocumentReader.SearchFilterValue): string => {
		return filterValue.isSelected ? "mimic-element is--selection-selected" : "mimic-element ";
	}

	render() {
		return <ul>
			{this.store.additionalFilterValuesWizardState.additionalFilterValues.map((filterValue) => {
				return <li key={filterValue.caption} className={this.itemClass(filterValue)}>
					<a onClick={this.handleClickItem.bind(this, filterValue)}>
						{
							this.store.additionalFilterValuesWizardState.currentFilterToAddFilterValues.filterMode == Shared.FilterMode.Single ?
								<span className="mimic-element__radio-style"></span> :
								<span className="mimic-element__checkbox-style"></span>
						}
						<span className="additionalfiltervalue-label">
							{filterValue.caption}
						</span>
						{
							filterValue.occurrences > 0 ? <span className="mimic-element__content-count">{filterValue.occurrences}</span> : null
						}
					</a>
				</li>
			})}
		</ul>;
	}
}